import { hooks } from "@feathersjs/authentication-client";
import { search } from "core-js/fn/symbol";
import { add, filter } from "lodash";
import { h } from "vue";

export default {
  // Loading Page
  loading: {
    title: "Getting Your Workspace Ready",
    message: "Please wait while we prepare your dashboard..."
  },
  // Sidebar Navigation
  sidebar: {
    dashboard: "Dashboard",
    plans: "Plans",
    evaluation: "Evaluation",
    talentPool: "Talent Pool",
    reports: "Reports",
    notifications: "Notifications",
    switchOrg: "Switch Org",
    settings: "Settings"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relationship added successfully",
    relationshipRemovedSuccessfully: "Relationship removed successfully",
    relationshipSavedSuccessfully: "Relationship Saved Successfully",
    profileCard: "Profile Card",
    viewOptions: {
      plan: "Plan",
      hierarchy: "Hierarchy",
      network: "Network"
    },
    searchPlaceholder: "Search users...",
    networkSearchPlaceholder: "Search network...",
    hierarchySearchPlaceholder: "Search hierarchy...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Create",
      roleCreatedSuccessfully: "Role Created successfully",
      delete: "Delete",
      roleDeletedSuccessfully: "Role deleted successfully",
      addProfile: "Add Profile",
      profileAddedSuccessfully: "Profile added successfully",
      removeProfile: "Remove Profile",
      profileRemovedSuccessfully: "Profile removed successfully",
      roleUpdate: "Role Update",
      updatedSuccessfully: "Updated successfully",
      profileUpdate: "Profile Update",
      profileUpdatedSuccessfully: "Profile updated successfully"
    },
    title: "Talent Pool",
    reviewRequest: "Review Request",
    // Main talent pool
    noPendingRequest: "No pending request found",
    dropresume: "Drop Resumes to Import",
    processingResume: "Processing Resumes...",
    draganddropPopup: "Drag & Drop your resumes here",
    Clicktoselectfiles: "or click to select files",
    Supportedfileformats: "Supported file formats: PDF, DOC, DOCX, TXT.",
    Maxuploadsize: "Maximum 10 files per upload.",
    processingStatus: "Processing Status",
    importResumes: "Import Resumes",
    UploadNewResume: "Upload New Resume",
    choosefile: "Choose File",
    AddMembers: "Add Members",
    email: "Email",
    contact_info: "Contact Info",
    career_objective: "Career Objective",
    Upload_More_Resumes: "Upload More Resumes",
    accessLevel: "Access Level",
    roleTitle: "Role Title",
    firstName: "First Name",
    lastName: "Last Name",
    AddRelationship: "Add Relationship",
    RelationshipSavedSuccessfully: "Relationship Saved Successfully",
    RelationshipAddedSuccessfully: "Relationship added successfully",
    RelationshipRemovedSuccessfully: "Relationship removed successfully",
    processingComplete: "Processing Complete",
    uploadingAndParsing: "Uploading and Parsing...",
    parsingProfiles: "Parsing Profiles...",
    total_progress: "Total Progress",
    Batches_in_queue: "Batches in Queue",
    no_objective_provided: "No objective provided.",
    view_talent_card: "View Talent Card",
    skills: "SKILLS",
    deactivateUserTitle: "Deactivate User from Organization",
    areYouSure: "Are you sure you want to deactivate",
    fromThisOrganization: "from this Organization?",
    deactivate_user: "Deactivate User",
    deactivationInProgress: "Deactivation In Progress...",
    confirm: "Confirm",
    noEmailOnRecord: "No email on record for this user",
    Resume_Preview: "Resume Preview",
    processed: "processed",
    done: "Done",
    failed: "Failed",
    finish: "Finish",
    Resume_not_found: "Resume not found",
    we_could_not_find_resume: "We couldn't find a resume for",
    pleaseSelectFile: "Please select a supported file to upload it now.",
    verify: "Verify and Upload",
    uploading: "Uploading...",
    downloadResume: "Download Resume",
    previewNotAvailable: "Preview Not Available",
    importFrom: "Import from",
    uploadExcel: "upload excel",
    uploadResumes: "upload resumes",
    uploadResumesTooltip: "Import from Resumes (PDF)",
    orHRIS: "or HRIS",
    pendingRequest: "Pending Request",
    allUsers: "All Users",
    addNewEmployee: "Add New Employee Card",
    // Table headers
    name: "Name",
    email: "Email",
    maxRole: "Roles",
    relationships: "Relationships",
    action: "Action",
    // User search
    searchUser: "Search User",
    userNotFound: "User not found.",
    // Relationship management
    member: "Member",
    relationship: "Relationship",
    addRelation: "Add relation",
    removeRelationship: "Remove Relationship",
    // Add employee form
    firstName: "First Name",
    lastName: "Last Name",
    roleTitle: "Role Title",
    save: "Save",
    // Import
    importFromExcel: "Import from Excel"
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Frequently Asked Questions",
    question1: "How do I manage my organization settings?",
    question2: "How can I invite new members to my organization?",
    question3: "What are the different user roles and permissions?",
    question4: "How do I customize my organization's branding?",
    helpText: "This is placeholder help text. Please contact support for specific assistance with your organization settings and configuration."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Organization Name",
    organizationUsername: "Organization Username",
    website: "Website",
    workEmail: "Work Email",
    location: "Location",
    organizationType: "Organization Type",
    primaryThemeColor: "Primary Theme Color",
    secondaryThemeColor: "Secondary Theme Color",
    about: "About",
    saveChanges: "Save Changes",
    usernameExists: "This username already exists",
    usernameAvailable: "This username is available",
    organizationTypeOptions: {
      business: "Business",
      academic: "Academic",
      recruiter: "Recruiter"
    },
    logo: {
      adjustTitle: "Adjust Organization Logo",
      save: "Save",
      uploadButton: "Upload Logo",
      incorrectFileType: "Incorrect File Type",
      incorrectFileTypeText: "Please upload a supported image file type, e.g. jpg, png, etc.",
      fileSizeExceeded: "Image File Size Exceeded",
      fileSizeExceededText: "The size of the profile picture should be less than 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Select",
    acceptInvitation: "Accept Invitation",
    noOrganizationFound: "No Organization Found!",
    noOrganizationSubtext: "Curate your own organization first.",
    createOrganization: "Create Organization",
    myOrganizations: "My Organizations",
    viewAllOrganizations: "View All Organizations",
    pendingInvitation: "Pending",
    currentOrg: "Current Organization"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Welcome Back! 👋",
    setupComplete: "Setup Complete!",
    setupProgress: "Setup: {step} of 4",
    copyLink: "Copy link",
    linkCopied: "Link copied",
    criticalRoles: "Critical Roles",
    talentPool: "Talent Pool",
    integrations: "Integrations",
    onboarding: "Onboarding",
    activeCandidates: "Active Candidates",
    connectedApps: "Connected Apps",
    pendingOnboards: "Pending Onboards",
    kvdrReportsCenter: "KVDR Reports Center",
    kvdrReportsDescription: "Dive deep into your key visual data reports and gain critical insights.",
    exploreReports: "Explore Reports >",
    talentPoolExplorer: "Talent Pool Explorer",
    talentPoolDescription: "Discover, analyze, and manage your top talent with comprehensive insights.",
    exploreTalentPool: "Explore Talent Pool >",
    thisMonth: "this month",
    goToOnboarding: "Go to Onboarding",

    addWebsiteLink: "Add website link",

    keyRoles: "Key Roles",
    activePlans: "Active Plans",
    completedPlans: "Completed Plans",
    viewCandidates: "View Candidates",
    accrossOrganization: "Across Organization",
    viewBoards: "View Boards",
    archived: "Archived/Finished",

    topRolesDistribution: "Top Roles Distribution",
    employees: "Employees",
    noData: "No data available yet.",

    plansVelocity: "Plans Velocity",
    pv_desc: "Comparison of active vs completed strategic plans.",
    active: "Active",
    completed: "Completed",

    kvdrReports: "KVDR Reports",
    kvdrReports_desc: "Generate insights and download visual reports",
    talentExplorer: "Talent Explorer",
    talentExplorer_desc: "Mange your candidates and employees",

    allSet: "All set!",
    stepInProgress: "Step In Progress:",
    completeProg: "Your organization profile is 100% complete.",
    incompleteProg: "You are on Step {onboardingStep} of 4. Complete your profile to unlock full features.",
    continueSetup: "Continue Setup",
    viewDetails: "View Details",

    onboardingSteps: {
      welcome: "Welcome",
      welcome_desc1: "Let's set up your talent pool to kick off your KVDR journey and power your talent strategy!",
      welcome_desc2: "Follow these steps to align talent to what truly drives business outcomes and build a data-backed talent ecosystem.",
      step1_title: "Define Organization Roles",
      step1_desc: "Structure teams around value-critical roles.",
      step2_title: "Add Talent",
      step2_desc: "Import people data from any source.",
      step3_title: "Evaluate",
      step3_desc: "Set up your indicators to evaluate talent based on what matters most to your organization.",
      step4_title: "Plan",
      step4_desc: "Turn insights into fitment, development & succession actions with talent plan for each role.",
      next: "Next",
      previous: "Previous",
      done: "Done",
      import: "Import &",
      finish: "Finish",

      step1: {
        title: "Organization Structure",
        description: "We have initialized your organization workspace. Click below to customize your departments, roles, and hierarchy settings in the Organization Planner.",
        departments: "Departments",
        departments_desc: "Manage business units",
        roles: "Roles",
        roles_desc: "Define job titles",
        hierarchy: "Hierarchy",
        hierarchy_desc: "Set reporting lines",
        instructions: "Click any card above to open the Organization Planner, or click 'Next' to proceed to Import.",
      },

      step2: {
        title: "Choose your upload method",
        title2: "Resume Files",
        description: "Drag & drop or Click to browse",
        instructions: "Supported formats: PDF, .txt, .doc, .docx",
      },

      step4: {
        title: "Final Step: ",
        title2: "You are on Step 4 of 4. Review your talent insights below.",
        button: "Finish Setup",
      },
    }
  },

  // Reports
  reports: {
    title: "Reports",
    nineCellMatrix: "9 Cell Matrix",
    xyPlot: "Scatter Plot",
    talentScoreCard: "Talent Scorecard",
    emptyReports: "Empty Reports",
    createKVDRFirst: "Create a KVDR and plan first to view reports",
    // XY Plot specific
    xAxis: "X-Axis",
    yAxis: "Y-Axis",
    bubbleSize: "Bubble Size",
    loadingChart: "Loading chart...",
    howToReadChart: "How to read this chart",
    positioning: "Positioning",
    horizontalPosition: "Horizontal position shows",
    verticalPosition: "Vertical position shows",
    bubbleRepresentation: "Bubble Representation",
    eachBubbleRepresents: "Each bubble represents an employee",
    sizeIndicates: "Size indicates",
    quadrants: "Quadrants",
    topLeft: "Top-Left",
    topRight: "Top-Right",
    bottomLeft: "Bottom-Left",
    bottomRight: "Bottom-Right",
    low: "Low",
    high: "High",
    interaction: "Interaction",
    hoverOverBubble: "Hover over any bubble",
    revealsDetailedMetrics: "Reveals detailed metrics for that employee",
    colorCoding: "Color coding",
    differentColorsHelp: "Different colors help distinguish employees",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Nine-Cell Matrix Employee Categorization",
    methodologyDescription: "Standardized methodology based on Performance Score and Succession Readiness",
    loading: "Loading...",
    preparingMatrix: "Preparing the Nine-Cell Matrix...",
    noDataAvailable: "No data available",
    employeeAssessmentRequired: "Employee assessment data is required to display the Nine-Cell Matrix.",
    successionReadiness: "Succession Readiness",
    performanceScore: "Performance Score",
    bargain: "BARGAIN",
    bind: "BIND",
    backup: "BACKUP",
    onTrack: "ON TRACK",
    boost: "BOOST",
    build: "BUILD",
    bootBarter: "BOOT/BARTER",
    employees: "Employees",
    methodologyTitle: "Nine-Cell Matrix Methodology",
    methodologySubtitle: "Standardized employee categorization based on Performance Score and Succession Readiness calculations.",
    calculationMethod: "Calculation Method",
    performanceScoreFormula: "Performance Score (P)",
    performanceScoreCalculation: "P = 0.6 × Performance + 0.4 × Appraisal",
    performanceScoreNote: "Raw scores (-1 to 1.5) are normalized to 0-100 scale",
    successionReadinessFormula: "Succession Readiness (R)",
    successionReadinessCalculation: "R = 0.5 × Succession + 0.3 × Fitment + 0.2 × Years Score",
    successionReadinessNote: "Raw scores (-1 to 1.5) are normalized to 0-100 scale",
    yearsScore: "Years Score",
    yearsScoreCalculation: "If Years ≥ 3: 100, else: (Years / 3) × 100",
    yearsScoreNote: "Currently using default 2 years (configurable)",
    cellCategories: "Cell Categories",
    backupDescription: "High Performance, High Succession",
    boostDescription: "Medium Performance, High Succession",
    bindDescription: "High/Medium Succession, Low/Medium Performance",
    onTrackDescription: "Medium/Low Performance, Medium/Low Succession",
    buildDescription: "Medium Performance, Low Succession",
    bargainDescription: "Low Performance, High Succession",
    bootBarterDescription: "High Performance, Low Succession",
    // Talent Score Card specific
    criteria: "Criteria",
    talent: "TALENT",
    role: "ROLE",
    remarks: "REMARKS",
    weightage: "Weightage",
    good: "Good (8-10)",
    average: "Average (5-7)",
    poor: "Poor (1-4)",
    notApplicable: "Not Applicable"
  },


onboarding: {
    define_kvdr: "Define KVDRs - Critical Roles",
    align_talent: "ALIGN TALENT TO WHAT DRIVES BUSINESS",
    map_org: "Map your organization by identifying:",
    core_func: "Core functions & departments",
    kvdr: "Key Value Delivery Roles (roles that materially impact strategy & growth)",
    reporting: "Reporting lines and role criticality",
    outcome: "Outcome:",
    tile1: "A business-aligned organizational blueprint with a look of an org chart.",
    tile2: "A live, searchable talent pool ready for analysis; internal & external.",
    tile3: "Bias-reduced, forward-looking talent signals.",
    tile4: "Data-backed talent plans for hiring, upskilling, succession & growth.",
    completed: "Completed",
    start_now: "Start Now",
    pending: "Pending",
    talent_ecosystem: "Build Your Talent Ecosystem",
    single_source: "SINGLE SOURCE OF TRUTH FOR YOUR PEOPLE DATA",
    bring_workforce: "Bring your workforce into GetBoarded by:",
    uploading_cvs: "Uploading CVs, Excel, or role profiles",
    hris: "Connecting your HRIS (if available)",
    enrichment: "Enrichment with skills, abilities & aspirations",
    career_trajectories: "Evaluate Career Trajectories",
    beyond_performance: "BEYOND PERFORMANCE & POTENTIAL STATS",
    configure: "Configure how talent is assessed by:",
    gb_trajectories: "Using GetBoarded's trajectory models (Fitment, Performance, Succession)",
    custom_parameters: "Customizing parameters aligned to your context",
    weighing_signals: "Weighing signals that matter now and in future",
    talent_plans: "Generate Talent Plans",
    insights_to_execution: "TURN INSIGHTS INTO EXECUTION",
    unlock: "Instantly unlock:",
    role_talent: "Role-to-talent misalignment insights",
    risk_mapping: "Succession readiness & risk mapping",
    mobility: "Hiring, mobility & development plans", 
    define_org_roles: "Define Organization Roles",
    add_talent: "Add Talent",
    evaluate: "Evaluate",
    plan: "Plan",
  },


  // Users
  users: {
    title: "Users",
    manageUsers: "Manage Users",
    // User Recommendations
    talentRecommendations: "Recommended Plans",
    guide: "Guide",
    paid: "PAID",
    free: "FREE",
    open: "OPEN",
    recommendationsDescription: "Based on your KVDR assessment, here are personalized plans for your organization",
    viewActivePlans: "View Active Plans",
    // Recommendation Cards
    hiringPlan: "Ecosystem Building",
    hiringPlanDescription: "Talent Onboaring",
    hiringPlanDescription1: "A structured workspace to invite people to your organization.",
    hiringPlanContent1: "Pipeline Tracking",
    hiringPlanContent2: "Candidate Management",
    hiringPlanContent3: "Customizable Stages",
    fitmentPlan: "Fitment Plan",
    fitmentPlanDescription: "Onboarding people to their roles.",
    fitmentPlanContent: "Onboarding people to their roles. Mapping right talent to right roles with fitment indicators",
    developmentPlan: "Development Plan",
    developmentPlanDescription: "AI-Powered Learning with ALEX",
    developmentPlanContent: "Creating Learning plans with ALEX Personalized learning paths to increase talent value with skills.",
    successionPlanning: "Succession Plan",
    successionPlanningDescription: "Promote and support career growth",
    successionPlanningContent: "Promote and support career growth Coaching plans for skill and time readiness to the next role.",
    // Benefits Lists
    roadToRole: "Road to your Role (Journey)",
    skillProfiling: "Skill profiling",
    learningCredits: "Learning credits",
    marketRewards: "Market rewards",
    customLearningPaths: "Custom learning paths",
    aiAssistedValidation: "AI assisted validation",
    progressTracking: "Progress tracking with Learning Credits",
    interactiveExercises: "Interactive exercises",
    appraisalIndicators: "360 Appraisal indicators",
    goalSettingMentorship: "Goal Setting & Mentorship",
    behaviouralCoaching: "Behavioural Coaching & Plans",
    careersuccession: "Career Succession & Planning",
    managedCareerGuidance: "Managed Career Guidance",
    starthiring: "Inviting",
    startonboarding: "Onboarding",
    startdevelopment: "Learning",
    startcoaching: "Coaching",
    contactus: "Contact Us",
    myplans: "My Plans",
    workspaces: "Manage your organization's workspaces",
    loadingplans: "Loading your plans...",
    completePayment: "Complete Payment",
    gettingstarted: "Getting Started",
    learnsetup: "Learn how to set up and manage talent plans for your organization",
    needhelp: "Need help? Reach out to us at",
    letsgetustarted: "Let's Get You Started",
    loadingmembers: "Loading members...",
    looksgood: "Looks good, next",
    design: "Design my journey",
    launchplan : "Launch Plan",
    pay: "Pay & Launch",
    plansummary: "Plan Summary",
    ordersummary: "Order Summary",
    back: "Back",
    addstep: "Add a step",
    journeyHint: "Participants will progress through these steps from top to bottom. You can always change this later.",
    finishPayment: "Finish payment to activate your plan",
    participants: "participants",
    paymentdetails: "Payment details",
    noMatches: "No one matches your search",
    added: "added",
    step: "Step",
    designedjourney: "Here's the journey we designed",
    designedjournerydesc: "Tap any title or description to edit it. You can add or remove steps too.",
    creatingJourney: "Creating your journey...",
    designingSteps: "Designing the steps participants will follow",
    suggestedname: "Suggested name",
    howManyParticipants: "How many participants?",
    setNumberOfPeople: "Set the number of people who will go through this plan. You can add them by name later.",
    total: "Total",
    stepsinjourney: "steps in journey",
    continue: "Continue to Payment",
    manageplan: "Manage Plan",
    cancel: "Cancel",
    updatemembers: "Update Members",
    describeGoal: "What's the goal?",
    starttemplate: "Or start from a template",
    describeParticipants: "Describe what participants should go through. We'll design the journey for you.",
    updateparticipants: "Update the participants enrolled in this plan.",
    tailorplandesc: "Our team will tailor this plan to your organization's needs and have it ready for you. Drop us a line and we'll take it from here.",
    // Action Buttons
    onboard: "Onboard",
    activate: "Activate",
    promote: "Promote",
    // Progress Section
    talentCapabilitySnapshot: "Talent Capability Snapshot",
    lastUpdated: "Last updated: Today",
    refresh: "Refresh",
    // Score Labels
    industryLeader: "Industry Leader",
    highPerforming: "High Performing",
    competitive: "Competitive",
    developing: "Developing",
    foundationBuilding: "Foundation Building",
    // Notifications
    alexActivated: "ALEX Activated",
    alexActivatedText: "Your AI learning assistant is ready to help!",
    coachingRequestSent: "Coaching Request Sent",
    coachingRequestSentText: "A coach will contact you shortly!",
    rewardsMarketplace: "Rewards Marketplace",
    rewardsMarketplaceText: "Exploring available rewards and perks!"
  },

  // Integrations
  integrations: {
    title: "Integrations",
    manageIntegrations: "Manage Integrations"
  },

  // Admins
  admins: {
    title: "Admins",
    manageAdmins: "Manage Admins"
  },

  //User Dashboard
  userDashboard: {
    expertIn: "Expert In",
    knownFor: "Known For",
    walletCard: "Wallet",
    activeQuest: "Growth Plan",
    noDevelopmentPlans: "No growth plan active !",
    activityQueue: "Learning Activity",
    talentCard: "Talent Card",
    developmentCharter: "Development Charter",
    devchar: {
      suggested: "Suggested",
      fuctionalSkills: "Functional Skills",
      softSkills: "Soft Skills",
      news: "News",
      activityQueue: "Activity Queue",
      completedItems: "Completed Items"
    },
    sidebar: {
      dashboard: "Dashboard",
      boards: "Boards",
      community: "Community",
      wallet: "Wallet",
      notifications: "Notifications",
      myOrganizations: "My Organizations"
    },
    notifications: {
      learningActions: "Learning Actions",
      invites: "Admin Invites",
      manage: "Manage",
      acceptInvitation: "Accept Invitation",
      noNotifications: "No Notification Found!"
    },
    boards: {
      activeBoards: "Active Plans",
      archived: "Archived Plans",
      noBoards: "No Currently Active Plans",
      curate: "Activate your Career Plans through your organization.",
      goToOrg: "Go to Organizations"
    },
    wallet: {
      connectWallet: "Connect Wallet",
      walletHistory: "Wallet History",
      status: "Status",
      date: "Date",
      amount: "Amount",
      transactions: "Transactions",
      type: "Type",
      details: "Details",
      done: "Done",
      noTransactions: "No Data Availaasdasdble"
    },
    profileDropDown: {
      createOrganization: "Create Organization",
      settings: "Settings",
      logout: "Logout"
    },
    settings: {
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      dateOfBirth: "Date of Birth",
      gender: "Gender",
      about: "About",
      saveChanges: "Save Changes",
      account: "Account",
    },
     evaluation: {
      evaluation: "Evaluation",
      searchPlaceholder: "Search roles or candidates...",
      importResumes: "Import Resumes",
      draganddrop: "Drag & drop Resumes Here",
      clicktoselect: "or click to select files",
      supportedfiles: "Supported file formats: PDF, DOC, DOCX, TXT",
      maxfile: "Max 10 files per upload",
      notifications: "Notifications",
      norequests: "No requests available",
      refreshchart: "Refresh Chart",
      processing: "Processing...",
      processed: "processed",
      waiting: "WAITING",
      totalprogress: "Total Progress",
      queue: "Queue",
      batchedqueued: "Batch(es) queued",
      uploadbatch: "Upload Batch",
      hideandprocess: "Hide & Process in Background",
      deleterole: "Delete Role",
      openrole: "Role is Open",
      closedrole: "Role is Closed",
      addteammember: "Add Team Member",
      editrole: "Edit Role Definition",
      addroles: "Add Roles",
      requestrole: "Request Role",
      deleteconfirmation: "Delete Confirmation",
      activeassignments: "Active Assignments",
      assignedcandidates: "candidate(s) are currently assigned",
      deletewarning1: "Deleting this role will remove all assignments from the organization chart.",
      thisactioncannotbeundone: "This action cannot be undone.",
      confirmdelete: "Confirm Delete",
      subroles: "Sub-roles detected",
      thisrolehassubroles: "This role has",
      connectedsubrole: "connected sub-role(s).",
      deletewarning2: "Deleting this role will permanently remove all sub-roles and unassign all candidates.",
      clicktoviewevaluation: "Click to view Evaluation Data",
      searchcandidates: "Search candidates...",
      autorejected: "Auto-Rejected",
      candidates: "Candidates",
      filterby: "Filter by Role",
      moreoptions: "More Options",
      addtorole: "Add to Role",
      dismissprofile: "Dismiss Profile",
      added: "Added",
      fitmentdetails: "Fitment Details",
      addnewrole: "Add New Role",
      roleTitle: "Role Title",
      purpose: "What is this role's core purpose? (One-liner)",
      selectlevel: "Select level",
      functionalSkills: "Functional skills",
      softSkills: "Soft skills",
      responsibilities: "Responsibilities",
      mission: "Mission (JTBD)",
      primarygoal: "Primary Goal: The #1 thing this role must achieve",
      secondarygoal: "Secondary Goal: Supporting Objective",
      generateroledescription: "Generate Role Description",
      previewanddownload: "Preview & Download JD",
      createrole: "Create Role",
      nvr: "Non-Value-Recognized minimal direct business impact", 
      kvdrdetection: "KVDR Detection",
      currentclassification: "Current Classification",
      influence: "Influence",
      whatdrivesthisrole: "WHAT DRIVES VALUE IN THIS ROLE?",
      person: "The Person",
      role: "The Role Itself",
      whatkidnofvalue: "WHAT KIND OF VALUE? (select all that apply)",
      revenue:"Revenue", cost: "Cost", risk: "Risk", ops: "Ops", brand: "Brand", social: "Social", research: "Research", other: "Other", ip: "IP",
      canthisvalue: "CAN THIS VALUE BE EXPRESSED IN BUSINESS TERMS?",
      revenue: "Revenue Generated",
      costsaved: "Costs Saved",
      timereduced: "Time Reduced",
      qualityimproved: "Quality Improved",
      riskmitigated: "Risk Mitigated",
      capabilitybuilt: "Capability Built",
      valueinfluencescore: "VALUE INFLUENCE SCORE",
      noinfluence: "No influence",
      directdriver: "Direct driver",
      ownershipclarity: "OWNERSHIP CLARITY",
      diffuse: "Diffuse / unclear",
      clear: "One clear owner",
      svr: "Enables KVDRs indirect contribution",
      kvdr: "Direct driver of value creation",
      editrole: "Edit Role",
      saveChanges: "Save Changes",
      back: "Back", done: "Done",
      jobdescription: "Job Description",
      notspecified: "Not specified",
      todriveorgsuccess: "To drive organizational success",
      untitledrole: "Untitled Role",
      roledescription: "Role Description",
      nodescription: "No description provided.",
      nonespecified: "None specified",
      goals: "Goals",
      notspecified: "Not specified",
    },
    organization_design: {
      organizationDesign: "Organization Design",
      rootnode: "Organization Root Node",
      description: "this is the root node representing the organization. You cannot inspect or edit it like a standard role. Please select standard role cards to modify them.",
      gotit: "Got it",
      totalheadcount: "Total Headcount",
      selecttool: "Select Tool",
      zoomin: "Zoom In",
      zoomout: "Zoom Out",
    },
    careerSimulator: {
      uploadBlocked: "Upload Blocked",
      gotIt: "Got it",
      keyAchievements: "KEY ACHIEVEMENTS",
      appliedSkills: "APPLIED SKILLS",
      careerTrajectory: "Career Trajectory",
      careerDurationFlow: "A {duration}-YEAR FLOW OF ROLES, PROJECTS & SKILLS",
      experienceFlow: "EXPERIENCE FLOW",
      projectedNextMove: "PROJECTED NEXT MOVE",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      resetView: "Reset View",
      careerPeak: "🚀 CAREER PEAK",
      now: "NOW",
      complexity: "⚡ {score}/10 COMPLEXITY",
      aiPredictedNextStep: "AI PREDICTED NEXT STEP",
      externalMarketGoal: "External Market Goal",
      futureNodeDesc: "Based on your chosen path, this is the ultimate pinnacle role to aim for.",
      scrubHint: "Click & drag to pan · Scroll along the ribbon · Click any card to inspect",
      noCareerHistoryTitle: "No Career History",
      noCareerHistoryDesc: "We couldn't extract enough valid dates from the CV to build the timeline.",
      close: "Close",
      startWithCv: "Start with your CV",
      startWithCvDesc: "We've parsed a sample CV scan. You can upload your own — we'll auto-extract skills, projects and learning velocity.",
      uploadYourResume: "Upload Your Resume",
      dragDropBrowse: "Drag & drop your file here or browse • PDF, DOCX, DOC",
      selectFile: "Select File",
      deepAiScan: "Deep AI Scan in Progress",
      activeDocument: "Active Document",
      changeFile: "Change File",
      uploadedResumeTitle: "Your Uploaded Resume",
      storedInDb: "Stored in Database",
      loadedFromIntelligenceDb: "Loaded from Intelligence Database",
      identifyingCandidate: "IDENTIFYING CANDIDATE",
      parsingIdentity: "Parsing Identity...",
      careerVelocity: "Career Velocity:",
      scanning: "Scanning...",
      extractingSkills: "EXTRACTING SKILLS...",
      simulatingRoleFit: "SIMULATING ROLE FIT...",
      primaryPathway: "Primary Pathway",
      secondaryTarget: "Secondary Target",
      stretchRole: "Stretch Role",
      parsedScan: "PARSED SCAN",
      topSkills: "TOP SKILLS",
      moreCount: "+{count} more ➔",
      showLess: "← Show less",
      bestFitRolesTitle: "BEST-FIT ROLES (FROM CV)",
      typeOfWorkTitle: "Type of Work",
      typeOfWorkSubtitle: "What kind of work do you want to do?",
      selectTargetArea: "Select Target Area...",
      otherWriteOwn: "Other — write your own...",
      typeCustomTarget: "Type your custom target area...",
      typeOfWorkExamples: "Examples: Communications, Team Building, Coding, Creative, Analytical, Sales, Consulting...",
      industryFocusTitle: "Industry Focus",
      industryFocusSubtitle: "What type of interest field do you want to grow in?",
      selectIndustryFocus: "Select Industry Focus...",
      typeCustomIndustry: "Type your custom industry...",
      supportingSkillsTitle: "Supporting Skills",
      supportingSkillsSubtitle: "Select or add multiple skills that support this career.",
      typeCustomSkill: "+ Type a custom skill and press Enter...",
      alternateSkillsTitle: "Alternate Skills",
      alternateSkillsSubtitle: "Select or add secondary skills you are willing to learn.",
      typeCustomStretchSkill: "+ Type a custom stretch skill and press Enter...",
      alternatePathwaysTitle: "Your Alternate Career Pathways",
      alternatePathwaysSubtitle: "Anchored on \"{area}\". Click a role node to reveal its detailed prediction.",
      skillReadiness: "Skill Readiness",
      timeReadiness: "Time Readiness",
      viewingInternalTooltip: "Viewing Internal Org (Click for Market)",
      viewingMarketTooltip: "Viewing Overall Market (Click for Internal)",
      targetFunctionalArea: "Target Functional Area",
      careerTitlesProfession: "Career Titles / Profession",
      requiredSkills: "Required Skills",
      viewCareerHistoryTooltip: "View Career History",
      targetArea: "Target Area",
      roleNodeMeta: "Fit {fit}% • {time} • Click for details",
      have: "Have",
      stretchWillingToLearn: "Stretch (willing to learn)",
      gap: "Gap",
      hoverNodeHint: "Hover any node to isolate its flow",
      shortTerm: "Short Term",
      longTerm: "Long Term",
      growthBanner: "INCLUSIVE • PARTICIPATIVE • ENGAGING • ITERATIVE CAREER GROWTH",
      today: "TODAY",
      identificationActions: "Identification Actions",
      risk: "- Risk",
      readyNowMonths: "READY NOW • 0 MONTHS",
      riskDesc: "Step into these roles today — your current skill base already covers the core requirements.",
      emptyPaths: "No paths in this window.",
      developmentAction: "Development Action",
      potential: "+ Potential",
      readyShortlyMonths: "READY SHORTLY • 1-6 MONTHS",
      potentialDesc: "Plan, offer and develop scarce skills and behaviours to unlock these paths within two quarters.",
      opportunityAllocation: "Opportunity Allocation",
      success: "= Success",
      readyLaterMonths: "READY LATER • 6+ MONTHS",
      successDesc: "Build a talent runway — these paths require deeper capability investment but unlock higher-trajectory growth.",
      openRolesTitle: "Open roles that match your paths",
      openRolesSubtitle: "We map your predicted career paths against currently open roles by required-skill overlap.",
      matchPercent: "{percent}% match",
      mappedFromPath: "Mapped from your path: {path}",
      youHave: "YOU HAVE",
      stillMissing: "STILL MISSING",
      requesting: "Requesting...",
      acceptedByAdmin: "✓ Accepted by Admin!",
      declined: "❌ Declined",
      requestSent: "⌛ Request Sent...",
      requestJoin: "Request to Join Role",
      noExactMatchesTitle: "No exact matches right now",
      noExactMatchesDesc: "No open roles currently match your generated pathways in this organization.",
      department: "DEPARTMENT",
      overallFit: "Overall fit",
      youAlreadyHave: "YOU ALREADY HAVE",
      gapToClose: "GAP TO CLOSE",
      none: "None",
      back: "← Back",
      nextStep: "Next Step ➔",
      seePredictions: "See Predictions ➔",
      generating: "Generating...",
      matchOpenRoles: "Match Open Roles ➔",
      finishSaveProfile: "Finish & Save Profile",
      downloadProfile: "Download",
      secBlockError: "SECURITY BLOCK: The uploaded resume belongs to {email}, but you are logged in as {userEmail}.",
      failedResumeLoad: "Could not load the resume file from the database.",
      failedPredict: "Failed to generate complete career paths.",
      failedSave: "Failed to save metrics.",
      failedRequest: "Failed to request role. Please try again.",
      failedParse: "Failed to parse resume.",
      radarInitializing: "Initializing neural engines...",
      radarStructuring: "Structuring document nodes...",
      radarSkeptical: "Running Skeptical HR Analysis...",
      radarExtracting: "Extracting technical capabilities...",
      radarSimulating: "Simulating career pathways...",
      radarFinalizing: "Finalizing HR Intelligence scores...",
      aiMachineLearning: "AI & Machine Learning",
      backendDevelopment: "Backend Development",
      softwareEngineering: "Software Engineering",
      dataAnalytics: "Data & Analytics",
      infrastructure: "Infrastructure",
      architectureConsulting: "Architecture & Consulting",
      saas: "SaaS",
      fintech: "FinTech",
      healthtech: "HealthTech",
      ecommerce: "E-commerce",
      consulting: "Consulting"
    }
  },
};
